import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Input, Modal, Spin } from "antd";
import { CustomerContactType } from "../api/Representation";
import VehicleTypeSelect from "../../../components/VehicleTypeSelect";
import HelpLabel from "../../../components/HelpLabel";
import CustomerVehicleTareFormItems from "./CustomerVehicleTareFormItems";
import CustomerVehicleResource from "../api/CustomerVehicleResource";
import { axiosErrorHandler } from "../../../../../swzutils";
import CustomerContactSelect from "../CustomerContactSelect";
const CustomerVehicleModal = ({ open, customer, customerVehicle, onCancel, onUpdated }) => {
    const [networkRequestInProgress, setNetworkRequestInProgress] = useState(false);
    const [showTareFields, setShowTareFields] = useState(false);
    const [form] = Form.useForm();
    useEffect(() => {
        setShowTareFields(!customerVehicle);
        if (open) {
            form.setFieldsValue({
                registration: customerVehicle?.registration,
                description: customerVehicle?.description,
                vehicleTypeId: customerVehicle?.type?.id,
                regularDriverCustomerContact: customerVehicle?.regularDriverCustomerContact?.id,
            });
        }
    }, [customerVehicle, open]);
    const onOkClicked = (formValues) => {
        const request = {
            version: customerVehicle?.version,
            registration: formValues.registration,
            description: formValues.description,
            vehicleTypeId: formValues.vehicleTypeId,
            regularDriverCustomerContactId: formValues.regularDriverCustomerContact,
            tare: showTareFields ? {
                atSenderReceiverId: formValues.tareAtSenderReceiverId,
                tareTonnes: formValues.tareTonnes,
                effectiveAt: formValues.tareEffectiveAt
            } : undefined
        };
        setNetworkRequestInProgress(true);
        if (customerVehicle) {
            CustomerVehicleResource.update(customer.id, customerVehicle.id, request, onUpdated, axiosErrorHandler, () => setNetworkRequestInProgress(false));
        }
        else {
            CustomerVehicleResource.create(customer.id, request, onUpdated, axiosErrorHandler, () => setNetworkRequestInProgress(false));
        }
    };
    return (_jsx(Modal, { title: "Customer Vehicle", open: open, onOk: form.submit, onCancel: onCancel, destroyOnHidden: true, children: _jsx(Spin, { spinning: networkRequestInProgress, children: _jsxs(Form, { layout: "vertical", form: form, onFinish: onOkClicked, initialValues: {
                    registration: customerVehicle?.registration,
                    description: customerVehicle?.description,
                    vehicleTypeId: customerVehicle?.type?.id,
                    regularDriverCustomerContact: customerVehicle?.regularDriverCustomerContact?.id,
                }, children: [_jsxs(Card, { title: "Vehicle Details", children: [_jsx(Form.Item, { name: "registration", label: "Registration", normalize: (v) => (v ? v.toUpperCase() : v), rules: [
                                    { required: true, message: 'Please input a registration number.' },
                                    { pattern: /^[0-9A-Z \-]+$/, message: 'The registration should only contain letters, numbers (-) hyphen and spaces' },
                                    { max: 20, message: 'Please limit the registration to 20 characters.' }
                                ], children: _jsx(Input, { style: { textTransform: "uppercase" } }) }), _jsx(Form.Item, { name: "description", label: "Description", rules: [
                                    { required: true, message: 'Please input a description number.' },
                                    { max: 500, message: 'Please limit the description to 500 characters.' }
                                ], children: _jsx(Input, {}) }), _jsx(Form.Item, { name: "vehicleTypeId", label: "Vehicle Type", rules: [
                                    { required: true, message: 'Vehicle Type is required' }
                                ], children: _jsx(VehicleTypeSelect, { tenantId: customer.tenant.id }) }), _jsx(Form.Item, { name: "regularDriverCustomerContact", label: _jsx(HelpLabel, { title: "Regular Driver", helpText: "By entering in your regular driver they will automatically be selected." }), children: _jsx(CustomerContactSelect, { customerContactType: CustomerContactType.DRIVER, canChangeContactType: false, customerId: customer.id }) })] }), showTareFields &&
                        _jsx(Card, { title: "Initial Tare", extra: _jsx(Button, { onClick: () => setShowTareFields(false), children: "No initial tare" }), children: _jsx(CustomerVehicleTareFormItems, { tenantId: customer.tenant.id }) })] }) }) }));
};
export default CustomerVehicleModal;
